angular.module('core')
  .directive('imageOnLoad', [function () {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        element.bind('load', function() {
          scope.$apply(attrs.imageOnLoad);
        });
      }
    };
  }]);